import { StarRating } from "./StarRating";
import type { Review } from "@/types/review";

interface ReviewCardProps {
  review: Review;
  showArtist?: boolean;
  showImage?: boolean;
}

export function ReviewCard({ review, showArtist = true, showImage = true }: ReviewCardProps) {
  const displayName = review.display_anonymous ? "Anonymous" : review.client_name;
  const imageToShow = review.thumbnail_url || review.image_url;

  return (
    <div className="p-6 rounded-xl bg-[var(--color-bg-card)] border border-[var(--color-border)] h-full flex flex-col">
      <div className="flex items-center justify-between mb-3">
        <StarRating value={review.rating} readonly size="sm" />
        <span className="text-sm text-[var(--color-text-muted)] flex items-center gap-2">
          {review.source === "etsy" && (
            <span
              className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-[#f1641e]/15 text-[#f1641e]"
              title="Verified purchase review from our Etsy shop"
            >
              Etsy
            </span>
          )}
          {displayName}
        </span>
      </div>

      <div className="flex gap-4 mb-4 flex-1">
        {review.review_text ? (
          <p className="text-[var(--color-text)] line-clamp-4 flex-1">
            "{review.review_text}"
          </p>
        ) : (
          <p className="flex-1" />
        )}

        {showImage && imageToShow && (
          <div className="flex-shrink-0">
            <img
              src={imageToShow}
              alt="Commission artwork"
              className="w-20 h-20 object-cover rounded-lg"
            />
          </div>
        )}
      </div>

      {showArtist && review.artist_name && (
        <div className="pt-3 border-t border-[var(--color-border)] mt-auto">
          <p className="text-xs text-[var(--color-text-muted)] flex items-center gap-1.5">
            <span>Commissioned from</span>
            {review.artist_profile_picture ? (
              <img
                src={review.artist_profile_picture}
                alt={review.artist_name}
                className="w-4 h-4 rounded-full object-cover"
              />
            ) : (
              <span className="w-4 h-4 rounded-full bg-[var(--color-primary)]/20 flex items-center justify-center text-[8px] font-bold text-[var(--color-primary)]">
                {review.artist_name.charAt(0).toUpperCase()}
              </span>
            )}
            <span className="text-[var(--color-primary)] font-medium">
              {review.artist_name}
            </span>
          </p>
        </div>
      )}
    </div>
  );
}
